type ErrorWithHttpStatus = {
  readonly response: {
    readonly status?: number;
  };
};

function getHttpStatus(error: unknown) {
  return hasResponseObject(error) && typeof error.response.status === 'number'
    ? error.response.status
    : undefined;
}

export function hasHttpStatus(error: unknown, status: number) {
  return getHttpStatus(error) === status;
}

function hasResponseObject(error: unknown): error is ErrorWithHttpStatus {
  return (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof error.response === 'object' &&
    error.response !== null
  );
}
